var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"confirmPetition"},[_c('h1',[_vm._v("You have successfully confirmed your petition signature")]),_c('a',{staticStyle:{"color":"black"},attrs:{"href":"https://peopleoverprof.it/"}},[_vm._v("Return to Homepage")]),_c('loader',{staticClass:"imageLoader",attrs:{"loading":_vm.loading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }